export const StreamPricingType = {
  Free: 'free',
  Paid: 'paid',
  PackageOnly: 'packageOnly',
};
export type StreamPricingType =
  (typeof StreamPricingType)[keyof typeof StreamPricingType];
